import React, { useState, useRef, useEffect } from 'react';
import style from './FooterContactForm.module.css';
import axios from 'axios';
import ThankYou from '../ThankYou/ThankYou';
import { API_URL } from '../../const';



const FooterContactForm = () => {

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");

    const [selectCountry, setSelectCountry] = useState('Select your country');
    const [countryError, setCountryError] = useState("");

    const [selectInterests, setSelectInterests] = useState('I’m interested in...');
    const [interestsError, setInterestsError] = useState("");

    const [message, setMessage] = useState("");
    const [messageError, setMessageError] = useState("");

    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState("");

    const [form, setForm] = useState(true);
    const [thankYou, setThankYou] = useState(false);

    const [disableButton, setDisableButton] = useState(false);

    const handlerName = (e) => {
        setName(e.target.value);
        if (name) setNameError(false)
    };

    const handlerEmail = (e) => {
        setEmail(e.target.value.toLowerCase());
        const re = /^(([^а-яА-Я<>()[\]\.,;:\s@\"]+(\.[^а-яА-Я<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@([a-zA-Z0-9!#$%&'*+\-\/=?^`{|}~]+(\.[a-zA-Z0-9!#$%&'*+\-\/=?^`{|}~]+)*\.[a-zA-Z]{2,})$/; if (!re.test(String(e.target.value).toLowerCase())) {
            setEmailError('*Please enter valid e-mail address.');
        } else {
            setEmailError('');
        }
    }

    const handlerMessage = (e) => {
        setMessage(e.target.value);
        if (message) setMessageError(false)
    }

    useEffect(() => {
        if (selectCountry !== 'Select your country') setCountryError(false)
        if (selectInterests !== 'I’m interested in...') setInterestsError(false)
    }, [selectCountry, selectInterests]);

    const handlerFile = (e) => {
        setFile(e.target.files[0]);
        if (e.target.files[0].size > 5242880) {
            setFileError('*The attached file must be no larger than 5 MB.');
        } else {
            setFileError('');
        }
    };

    const select1 = useRef();
    const select2 = useRef();

    const selectToggle1 = () => {
        select1.current.classList.toggle(style.isActive);
        select2.current.classList.remove(style.isActive);
    }
    const selectToggle2 = () => {
        select2.current.classList.toggle(style.isActive);
        select1.current.classList.remove(style.isActive);
    }

    const selectChoose1 = (e) => {
        const text = e.target.innerHTML;
        setSelectCountry(text);
        select1.current.classList.remove(style.isActive);
    }

    const selectChoose2 = (e) => {
        const text = e.target.innerHTML;
        setSelectInterests(text);
        select1.current.classList.remove(style.isActive);
        select2.current.classList.remove(style.isActive);
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutsideSelect, { passive: true })
        return () => {
            document.removeEventListener("click", handleClickOutsideSelect);
        };
    }, [select1, select2]);

    const handleClickOutsideSelect = (e) => {
        if (select1.current && !select1.current.contains(e.target)) {
            select1.current.classList.remove(style.isActive);
        }
        if (select2.current && !select2.current.contains(e.target)) {
            select2.current.classList.remove(style.isActive);
        }
    }

    const thankYouMobile = () => {
        const windowInnerWidth = window.innerWidth;
        if (windowInnerWidth < 768) {
            setForm(false)
            let container = document.querySelector(`.${style.container}`);
            container.style.height = '750px';
            container.style.paddingTop = '160px';
        }
    }

    useEffect(() => {
        setDisableButton(false);
    }, [name, email, selectCountry, selectInterests, message, file]);

    const submitForm = (name, email, selectCountry, selectInterests, message, file) => {

        const formData = new FormData();
        formData.append('file', file);

        if (name === '') {
            setNameError('*Please enter your full name.');
        }
        if (email === '') {
            setEmailError('*Please enter your e-mail address.');
        }

        if (message === '') {
            setMessageError('*Please enter your message.');
        }
        if (selectCountry === 'Select your country') {
            setCountryError('*Please select your country.');
        }

        if (selectInterests === 'I’m interested in...') {
            setInterestsError('*Please select your interest.');
        }

        if (nameError === false
            && emailError === ''
            && messageError === false
            && countryError === false
            && interestsError === false
            && fileError === ''
        ) {
            thankYouMobile()
            setDisableButton(true);

            if (file) {

                axios.post(`${API_URL}/api/upload-file`, formData)
                    .then((res) => {
                        axios.post(`${API_URL}/api/send-form`, {
                            name,
                            email,
                            country: selectCountry,
                            interest: selectInterests,
                            message,
                            attachmentUrl: res.data.url,
                            attachmentName: res.data.name
                        })
                            .then(() => {
                                setThankYou(true)
                                setDisableButton(false);
                            })
                            .catch((error) => {
                                console.log('send-form error', error)
                            })
                    })
                    .catch((error) => {
                        console.log('upload-file error', error)
                    })

            } else {

                axios.post(`${API_URL}/api/send-form`, {
                    name,
                    email,
                    country: selectCountry,
                    interest: selectInterests,
                    message
                })
                    .then(() => {
                        setThankYou(true)
                        setDisableButton(false)
                    })
                    .catch((error) => {
                        console.log('send-form error', error)
                    })
            }
        }
    }


    let country_list = [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla",
        "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia",
        "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
        "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia",
        "Bosnia and Herzegovina", "Botswana", "Brazil", "British Virgin Islands",
        "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia",
        "Cameroon", "Canada", "Cayman Islands", "Central African Republic",
        "Chad", "Chile", "China", "Colombia", "Comoros",
        "Cook Islands", "Costa Rica", "Côte d'Ivoire",
        "Croatia", "Cuba", "Cyprus", "Czechia", "Denmark", "Djibouti",
        "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
        "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
        "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France",
        "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia",
        "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam",
        "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti",
        "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia",
        "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica",
        "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo",
        "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia",
        "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau",
        "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta",
        "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
        "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco",
        "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
        "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria",
        "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
        "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru",
        "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion",
        "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
        "Saint Vincent and the Grenadines", "Samoa", "San Marino",
        "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone",
        "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
        "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka",
        "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan",
        "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga",
        "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan",
        "Turks and Caicos", "Tuvalu", "Uganda", "Ukraine",
        "United Arab Emirates", "United Kingdom", "United States", "Uruguay",
        "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands (US)",
        "Yemen", "Zambia", "Zimbabwe"
    ];

    let interests = ['Dedicated Development Team', 'Outsource', 'Outstaff', 'Native Mobile Development', 'Flutter', 'Web Development', 'UX/UI Design', 'Quality Assurance', 'I don’t know…'];


    return (
        <div className={style.wrapper} id='contactForm__wrapper'>
            <div className={style.container} >

                {form && (
                    <>
                        <div className={style.information}>
                            <h2 className={style.information__title} id="contact">Let’s build something<br />great together!</h2>
                            <p className={style.information__text} >Fill out the form below so our team can get in touch with you within a few days. We will analyze your request and come back with fresh ideas. We are delighted by your presence.</p>
                        </div>

                        <div className={style.form} >

                            <div className={style.inputWrapper}>
                                <label className={style.visuallyHidden} htmlFor="name">Enter your full name</label>
                                <input className={style.form__name}
                                    type="text"
                                    name="name"
                                    id="name"
                                    placeholder="Enter your full name"
                                    onChange={(e) => handlerName(e)}
                                    autoComplete="off"
                                />
                                {nameError && <p className={style.inputError}>{nameError}</p>}
                            </div>

                            <div className={style.inputWrapper}>
                                <div className={style.form__country}>
                                    <div className={style.select} ref={select1}>
                                        <div className={style.select__header} onClick={selectToggle1}>
                                            <span className={style.select__current}>{selectCountry}</span>
                                            <div className={style.select__icon}></div>
                                        </div>

                                        <div className={style.select__body}>
                                            {country_list.map((country, index) => (
                                                <div className={`${style.select__item}`} onClick={e => selectChoose1(e)} key={index}>{country}</div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                {countryError && <p className={style.inputError}>{countryError}</p>}
                            </div>

                            <div className={style.inputWrapper}>
                                <label className={style.visuallyHidden} htmlFor="email">Enter your E-mail address</label>
                                <input className={style.form__email}
                                    type="text"
                                    value={email}
                                    placeholder="Enter your E-mail address"
                                    onChange={(e) => handlerEmail(e)}
                                    autoComplete="off"
                                />
                                {emailError && <p className={style.inputError}>{emailError}</p>}
                            </div>

                            <div className={style.inputWrapper}>
                                <div className={style.form__interest}>
                                    <div className={style.select} ref={select2}>
                                        <div className={style.select__header} onClick={selectToggle2}>
                                            <span className={style.select__current}>{selectInterests}</span>
                                            <div className={style.select__icon}></div>
                                        </div>

                                        <div className={style.select__body}>
                                            {interests.map((interest, index) => (
                                                <div className={`${style.select__item}`} onClick={e => selectChoose2(e)} key={index}>{interest}</div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                {interestsError && <p className={style.inputError}>{interestsError}</p>}
                            </div>

                            <div className={style.inputWrapper}>
                                <label className={style.visuallyHidden} htmlFor="message">Write your message</label>
                                <textarea className={style.form__message}
                                    rows="5"
                                    type="text"
                                    name="message"
                                    id="message"
                                    placeholder="Write your message"
                                    onChange={(e) => handlerMessage(e)}
                                />
                                {messageError && <p className={style.inputError__message}>{messageError}</p>}
                            </div>

                            <div className={style.inputWrapper}>
                                <label className={style.form__file} htmlFor="file-input">
                                    <br />Drop file here {file && <small style={{ color: 'white', fontSize: '16px', width: '100px', height: 'auto', overflow: 'hidden' }}>{file.name}</small>}
                                </label>

                                <input className={style.visuallyHidden}
                                    id="file-input"
                                    type="file"
                                    name="file"
                                    accept=".pdf, .doc, .docx, .PDF, .DOC, .DOCX,"
                                    multiple
                                    onChange={(e) => handlerFile(e)} />
                                {fileError && <p className={style.inputError__file}>{fileError}</p>}
                            </div>

                            <button
                                className={style.form__button}
                                onClick={() => submitForm(name, email, selectCountry, selectInterests, message, file)}
                                disabled={disableButton}
                            >
                                Contact!
                            </button>

                        </div>
                    </>
                )}

                {thankYou && <ThankYou />}

            </div>
        </div>
    )
}

export default FooterContactForm;